module.exports = __webpack_public_path__ + "img/9788989675822.bc20948b.jpg";